import gql from 'graphql-tag';

export default gql`
  query getDeliveryFee($input: GetDeliveryFeeInput!) {
    getDeliveryFee(input: $input) {
      deliveryFee
      isFreeDelivery
      remainingToFree
      deliveryFeeThreshold
      additionalVat
      areaGroupName
      success
      message
    }
  }
`;
